
import React from 'react';
import { Button } from '../../../components/base/Button';
import { Link } from 'react-router-dom';

export const HeroSection: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/banners/hero-home.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <p className="text-lg md:text-xl mb-6 font-light">
            "A vacation is what you take when you can no longer take what you've been taking."—Earl Wilson.
          </p>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-8 leading-tight">
            Time for your next adventure
          </h1>

          <p className="text-xl md:text-2xl mb-12 font-light max-w-3xl mx-auto">
            We are travelers, the destination world wide as a home to explore and all destination and experience that we offering the travel experience is unique in nature
          </p>

          <div className="flex justify-center">
            <Link to="/group-tours" aria-label="Group Tours — group tours">
              <Button size="lg" className="text-lg px-12 py-4">
                <i className="ri-compass-3-line w-5 h-5 flex items-center justify-center"></i>
                Start Your Journey
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <i className="ri-arrow-down-line w-6 h-6 flex items-center justify-center"></i>
      </div>
    </section>
  );
};